// 下载操作处理
export function downloadFile (rsp,fileName) {
    const link = document.createElement("a");
    let blob = new Blob([rsp.data], { type: "application/vnd.ms-excel" });  //文件流处理
    // let blob = new Blob([rsp.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });  //文件流处理
    // let fileName = this.extractHeaderValue(rsp.data, 'fileName')
    // console.log(fileName)
    link.style.display = "none";  //去除a标签的样式
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
}

function extractHeaderValue (headers, key){
    let value = headers[key]
    if (value) return value
    value = headers[key.toLowerCase()]
    return value
}